<template>
  <div>
    <el-dialog
      title="线上结算服务介绍"
      class="online-pay-service"
      :visible.sync="onlinePayServiceVisible"
      width="55%"
      :destroy-on-close="true"
      :modal="false"
    >
      <div>
        <h3 class="text-center text-xl mb-6">开通线上结算</h3>
        <p class="text-center text-sm text-gray-800 mb-16">
          开通线上结算后，调研工厂将按调查员到手金额的 {{accountingRateVal}} 收取费用，用于调查员代缴税及平台技术服务费。同时，调研工厂为您的总花费金额开具 6% 的增值税专用发票或普通发票。
        </p>
        <img class="w-full" src="/assets/img/settlement/protocol-intro.png" />
      </div>
      <span slot="footer">
        <span v-if="isSign" class="cursor-auto">您已开通服务</span>
        <el-button v-else type="primary" @click="openService">前往企业钱包开通服务</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { wjSettleIsSign } from '@/api/wenjuan/settlement'
import GlobalConfig from '@/global/config'
import { getCurrentCompany } from '@/api/surveywork/customer'
import { getSurveyDomain } from '@/assets/js/config/env'
export default {
  data() {
    return {
      onlinePayServiceVisible: false,
      isSign: false,
      isSuperAdmin: null
    }
  },
  computed: {
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    }
  },
  methods: {
    wjSettleIsSign() {
      const companyId = GlobalConfig.getCompanyId()
      return wjSettleIsSign({ companyId }).then(res => {
        if (res.data.code == 0 && res.data.data == '已签约') {
          this.isSign = true
        }
      })
    },
    async openService() {
      await this.wjSettleIsSign() //更新是否签约，以防去其他页面签约后 再回到此页面未更新签约问题
      if (!this.isSign) {
        if (this.isSuperAdmin) {
          //去签约
          const token = GlobalConfig.getBaseToken()
          window.open(getSurveyDomain() + '/settlement?token=' + token)
        } else {
          this.$message.warning('您不是企业管理员，请联系企业管理员开通')
        }
      }
    },
    openDialog() {
      this.onlinePayServiceVisible = true
      this.wjSettleIsSign()
    }
  },
  created() {
    getCurrentCompany().then(res => {
      this.isSuperAdmin = res.data.owner
    })
  },
}
</script>

<style lang="scss" scoped>
::v-deep .online-pay-service {
  .el-dialog__footer {
    text-align: center !important;
  }
}
</style>
